import { Link } from "react-router-dom";
import { Card, Flex, Text } from "@suns/design-system";

export default function LabsCard({
  slug,
  subTitle,
  title,
  description,
}: {
  slug: string;
  subTitle: string;
  title: string;
  description: string;
}) {
  return (
    <Link to={`/labs/${slug}`} className="w-full">
      <Card>
        <Flex direction="down" gap="sm">
          <Flex direction="down">
            <Text heading size="sm" muted>
              {subTitle}
            </Text>
            <Text as="h2" heading size="xl" variant="primary">
              {title}
            </Text>
          </Flex>
          <Text>{description}</Text>
        </Flex>
      </Card>
    </Link>
  );
}
